module.exports = __webpack_public_path__ + "static/media/chart_growth.58a8919e.png";